let datePicker = document.querySelector('#date-picker .dates');
let dateText = document.querySelector('#date-picker .editable h1');
let editIcon = document.querySelector('#date-picker .editable .icon');
let scroller = document.querySelector('#date-picker .scroller');
let leftIcon = document.querySelector('#date-picker .left');
let rightIcon = document.querySelector('#date-picker .right');

if (editIcon && scroller) {
  editIcon.addEventListener('click', function(e) {
    if (scroller.classList.contains('hide')) {
      scroller.classList.remove('show');
      scroller.classList.add('show');

      editIcon.classList.remove('show-inline');
      editIcon.classList.add('hide');
    }
  });
}

if (datePicker && dateText && scroller && editIcon) {
  datePicker.addEventListener('click', function(e) {
    if (e.target.classList.contains('date')) {
      dateText.innerText = e.target.innerText.replace(/(\r\n|\n|\r)/gm, ' ');
    } else if (e.target.parentElement.classList.contains('date')) {
      dateText.innerText = e.target.parentElement.innerText.replace(/(\r\n|\n|\r)/gm, ' ');
    }
    scroller.classList.add('hide');
    scroller.classList.remove('show');

    editIcon.classList.remove('hide');
    editIcon.classList.add('show-inline');
  });
}

if (leftIcon) {
  leftIcon.addEventListener('click', function() {
    scroller.scrollLeft -= 350;
  });
}

if (rightIcon) {
  rightIcon.addEventListener('click', function() {
    scroller.scrollLeft += 350;
  });
}
